module.exports = __webpack_public_path__ + "img/jingd.e3e61fb0.png";